// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__ngFmX","label":"Radio_label__22lXv","checkMark":"Radio_checkMark__-oT2f","disabled":"Radio_disabled__3ZUOd"};